/*
 * @Description: 新闻管理api
 */
import request from '@/utils/request'

/**
 * 查询新闻列表
 */
export const getNewsList = async (data) => request({
	url: "/news/getByList",
	method: "POST",
	data
})

/**
 * 根据id查询新闻详情
 */
export const getNewsById = async (data) => request({
	url: "/news/getById",
	method: "POST",
	data
})

/**
 * 根据id列表查询新闻列表
 */
export const getNewsByIds = async (data) => request({
	url: "/news/getByIds",
	method: "POST",
	data
})

/**
 * 新增新闻
 */
export const addNews = async (data) => request({
	url: "/news/add",
	method: "POST",
	data
})

/**
 * 编辑新闻
 */
export const editNews = async (data) => request({
	url: "/news/edit",
	method: "POST",
	data
})

/**
 * 复制新闻
 */
export const copyNews = async (data) => request({
	url: "/news/copy",
	method: "POST",
	data
})



/**
 * 删除新闻
 */
export const deleteNews = async (data) => request({
	url: "/news/delete",
	method: "POST",
	data
})